import React, { ChangeEvent, ReactElement, useMemo, useState } from 'react';
import { TextField } from '@mui/material';
import { Autocomplete } from '@mui/material';
import { filterSelectedArticles, getArticleOptionString, isArticleSelected } from './AutocompleteHelper';
import { ArticleDto } from '../../../api/ClientApi';
import { useAppSelector } from '../../../hooks/hooks';
import { RootState } from '../../../redux/reducers';

type ArticleAutocompleteProps = {
    isRequired: boolean;
    articles: ArticleDto[];
    selectedArticleId?: number;
    selectArticle(articleId?: number): void;
};

export default function ArticleAutocomplete(props: ArticleAutocompleteProps): ReactElement {
    const { isRequired, articles, selectedArticleId, selectArticle } = props;
    const allArticles = useAppSelector((state: RootState) => state.articles.articles);

    const [articleFilter, setArticleFilter] = useState<string>('');

    const handleArticleIdSelect = (articleId?: number) => {
        selectArticle(articleId);
    };

    const handleArticleSelect = (event: ChangeEvent<unknown>, value: string | null): void => {
        if (value !== null) {
            const searchedArticle = articles?.find((a) => {
                return isArticleSelected(a, value);
            });

            if (!!searchedArticle && !!searchedArticle.id && searchedArticle?.id >= 0) {
                handleArticleIdSelect(searchedArticle.id);
            }
        } else {
            handleArticleIdSelect(undefined);
        }
    };

    const handleArticleFilterChange = (event: ChangeEvent<{ value: unknown }>): void => {
        const searchToken: string = (event.target.value as string) ?? '';

        setArticleFilter(searchToken);
    };

    const selectedValues = useMemo(() => {
        return selectedArticleId ? getArticleOptionString(allArticles?.find((a) => a.id === selectedArticleId)) : null;
    }, [allArticles, selectedArticleId]);

    return (
        <Autocomplete
            freeSolo
            options={articles.map((option) => getArticleOptionString(option))}
            filterOptions={(x) => {
                return filterSelectedArticles(x, articleFilter);
            }}
            value={selectedValues}
            onChange={handleArticleSelect}
            renderInput={(params) => (
                <TextField
                    {...params}
                    autoFocus
                    required={isRequired}
                    error={isRequired && (!selectedArticleId || selectedArticleId === 0)}
                    fullWidth
                    label="Artikal"
                    variant="outlined"
                    style={{ backgroundColor: '#f7f7f7', borderRadius: 5 }}
                    onChange={handleArticleFilterChange}
                />
            )}
        />
    );
}
